export default __webpack_public_path__ + "static/media/Bhojpuri_agri_f.d69ceab2.wav";